import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";

export const MarathonParticipantImagesApi = {
  getMarathonParticipantImageByFileId: async (
    fileId: string
  ): Promise<Blob> => {
    const response = await axiosApi.get(
      `/marathonParticipantImages/${fileId}`,
      {
        responseType: "blob",
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );

    return response.data;
  }
}

